const DESKTOP_SWATCH_LIMIT = 6;
const MOBILE_SWATCH_LIMIT = 4;

const getSwatchLimit = (isDesktop) => (isDesktop ? DESKTOP_SWATCH_LIMIT : MOBILE_SWATCH_LIMIT);

export { DESKTOP_SWATCH_LIMIT, MOBILE_SWATCH_LIMIT };
export default getSwatchLimit;
